import * as types from '@/actions/types'

const initialState = {
  route: [],
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.ROUTING_ADD:
      state = {
        ...state,
        route: Object.values(action.content),
      }
      break
    default:
      return { ...state }
  }
  return { ...state }
}

export default reducer
